import { AnswerType, ResponseFilter } from "@archetypes/form";
import { getQuestionIdFromVariable } from "./variables.util";
import { FormResponse } from "@archetypes/responses";

export const formatResponseFilter = ({
  filter,
  formValues,
}: {
  filter?: ResponseFilter;
  formValues: FormResponse;
}) => {
  if (!filter) {
    return;
  }
  const updatedFilter: ResponseFilter = { logicalOperator: filter.logicalOperator, fieldsets: [] };
  updatedFilter.fieldsets = filter.fieldsets.map((field) => {
    if (field.answerType === AnswerType.DYNAMIC) {
      const questionId = getQuestionIdFromVariable(field.answer as string);
      if (questionId) {
        return { ...field, answer: formValues[questionId], answerType: undefined };
      }
    }
    return { ...field, answerType: undefined };
  });
  return updatedFilter;
};
